import { Button } from 'components/Button/Button';
import type { CmsApiStickyHeaderLinksBlockData } from 'modules/cms/api/types/blocks/CmsApiStickyHeaderLinksBlock';
import { isUrlWithProtocol } from 'utils/url/isUrlWithProtocol';

import { CmsStickyHeaderLinks } from './CmsStickyHeaderLinks';
import { CmsStickyHeaderLinksBlockExternalLink } from './CmsStickyHeaderLinksBlockExternalLink';

type Props = {
  data: CmsApiStickyHeaderLinksBlockData;
};

export function CmsStickyHeaderLinksBlock({
  data: { links, buttonText, buttonUrl },
}: Props) {
  const hasButton = buttonUrl && buttonText;
  return (
    <CmsStickyHeaderLinks
      links={links}
      button={
        hasButton &&
        (buttonUrl && isUrlWithProtocol(buttonUrl) ? (
          <CmsStickyHeaderLinksBlockExternalLink href={buttonUrl}>
            {buttonText}
          </CmsStickyHeaderLinksBlockExternalLink>
        ) : (
          <Button type="link" variant="primary" href={buttonUrl}>
            {buttonText}
          </Button>
        ))
      }
    />
  );
}
